import { first } from 'rxjs'
import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ModalController } from '@ionic/angular'
import { SamplesServices } from '@services/requests/samples/samples.service'
import { AlertService } from '@services/utils/alerts/alert.service'
import { EndpointsService } from '@services/api/endpoints.service'
import { ApiService } from '@services/api/api.service'

@Component({
  selector: 'app-resume-sample',
  templateUrl: './resume-sample.page.html',
  styleUrls: ['./resume-sample.page.scss']
})
export class ResumeSamplePage implements OnInit {
  @Input() data

  url = this.endpointsService.url

  constructor(
    public endpointsService: EndpointsService,
    public apiService: ApiService,
    public samplesServices: SamplesServices,
    public alertService: AlertService,
    public router: Router,
    public modalController: ModalController
  ) {}

  ngOnInit() {}

  async create() {
    this.alertService.presentLoading()
    await this.apiService
      .create(this.url.sampleInfo, this.data)
      .pipe(first())
      .subscribe(
        (res) => {
          this.alertService.dismiss().then(() => {
            this.success(res)
          })
        },
        (err) => {
          this.alertService.dismiss().then(() => {
            this.alertService.statusErrorUpdate(err)
          })
        }
      )
  }

  success(res) {
    this.data = {}
    this.alertService.statusSuccessRegisterRequestSample()
    this.router.navigate(['home'])
    this.closeModal()
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
